import { Component, Input } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MatIconModule } from '@angular/material/icon'

@Component({
  selector: 'app-ping',
  imports: [CommonModule, MatIconModule],
  templateUrl: './ping.component.html',
  styleUrls: ['./ping.component.scss'],
})
export class PingComponent {
  @Input()
  score: number | null | undefined

  @Input()
  offline: boolean | null | undefined

  @Input()
  iconBase: string = 'network'

  constructor() {}
}
